module.exports = __webpack_public_path__ + "img/examDate@2x.dfc4cee6.png";